import React, { useState } from "react";
import classNames from "classnames";
import { BaseModal, IModalInstance, ModalHeader } from "@whatslly/ui-components/modals";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import { TextInput } from "@whatslly/ui-components/v2/BaseElements/TextInput";
import { Label } from "@whatslly/ui-components/v2/BaseElements/Label";
import { useTranslation } from "react-i18next";
import styles from "./modals/Modals.module.scss";

type SecurityOtherModalProps = IModalInstance<{ name: string }> & { initialName?: string };

export const SecurityOtherModal: React.FC<SecurityOtherModalProps> = ({ closeModal, initialName = "" }) => {
  const { t } = useTranslation();
  const [name, setName] = useState(initialName);

  return (
    <BaseModal
      header={<ModalHeader closeModal={() => closeModal()}>{t("destinations_page.security.other_modal_title")}</ModalHeader>}
      closeModal={() => closeModal()}
      closeOnClickOutside={false}
      closeOnEscape={true}
      testId="security-other-modal"
      headerClassName={styles.header}
      className={styles.messagesModal}
      bodyClassName={classNames(styles.body)}
    >
      <div className={styles.field}>
        <Label className={styles.filedLabel} text={t("user_management.invite_user_modal.security_stack")} />
        <TextInput
          type="text"
          value={name}
          placeholder={t("user_management.invite_user_modal.security_stack_other")}
          data-testid="security-other-name"
          inputSize="small"
          paddingInline="none"
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <ModalButtons testId="modal-buttons-submit-button" onCancel={() => closeModal()} onSubmit={() => closeModal({ name: name.trim() })} />
    </BaseModal>
  );
};
